import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { TimeService } from 'src/app/time.service';
import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';
import { Router } from '@angular/router';

export interface spotVehicleData {
  vehicle_no: string;
  vehicle_type: string;
  driver_licence_no?: string;
  driver_licence_expiry_date?: number;
  carrier_type?: string;
  driverImage?: string;
  comments?: string;
  dedicated_to: string;
  // rc_book_number?: string;

}
export interface spotData {
  name: string;
  mobile: string;
  // ws_opt_in: boolean;
}
export interface spotCapacityData {
  capacity?: number;
  vehicle_qty?: number;
  rc_Laden_weight?: number;
}

@Component({
  selector: 'app-partial-registration',
  templateUrl: './partial-registration.component.html',
  styleUrls: ['./partial-registration.component.scss']
})
export class PartialRegistrationComponent implements OnInit {

  spotVehicleData: spotVehicleData = {
    vehicle_no: '',
    vehicle_type: '',
    dedicated_to: '',
  };

  selectedUnit: any = {
    _id: '',
    name: '',
    };
  driverImage: any = '';
  spotDriverData: spotData = {
    name: '',
    mobile: '',
    // ws_opt_in: false,
  };
  capacityData: spotCapacityData = {
    capacity: 0,
    vehicle_qty: 0,
    rc_Laden_weight: 0,
  };

  preferred = {
    zone: '',
    location: '',
    load: '',
  };
  expiryDate;

  shippersArr = [];
  dedicatedShippersArr = [];
  dedicatedShipper = '';
  shipper = '';
  material = [];
  selectedMaterial = [];
  vehicle = '';
  carrier = '';
  carriredId = '';
  dedicatedId = '';
  spinner = false;
  checked = false;
  selectedVehicleType: any = {};
  showLoader = false;
  vehicleType: any = {};
  vehicleType1: any = {};
  vehicles: any = [];
  vehicle_pattern;
  defaultVehicle: any;

  selectedAsset;
  selectedCarriers = [];
  carrierSelection: any;
  filter: any = '';
  carrierList: any;
  vehicleTypes: any = [];
  states: any = [];
  carrierTypes: any = ['CT', 'PT'];
  carrier_type: any = '';
  stream: MediaStream;
  searchVehicleNo: string;
  vehicle_number = '';
  assignArr = [];
  materialsArr = [];
  registeredForId: any = [];
  registeredShipper: any;
  customer_name = '';
  
  chassis_number = '';
  engine_number = '';
  insurance: any = {
    no: '',
    expiry: '',
  };
  gps_providers = [];
  carrierId: Subscription;
  
  selectedGPSProvider;
  enbleMaterial = true;
  materialList:any=[{name:'',load:0}];
  allVehicles = [];
  countryCode: any = '';
  dedicated_to = ''; 
  constructor(

    private valid: ValidationService,
    private snackbar: SnackbarService,
    private http: HttpService,
    private translate: TranslateService,
    // @Inject(MAT_DIALOG_DATA) private parentData: any,
    private timeService: TimeService,
    private matDialog: MatDialog,
    private event: EventService,
    private router: Router
  ) { }

  ngOnInit() {
    const carriers = JSON.parse(localStorage.getItem('carriers'));
    this.countryCode = carriers[0].country._id || '';
    // this.getDedicatedShippers();
    this.gps_providers = [
      {
        name: 'Instavans',
        value: 'instavans'
      },
      {
        name: 'Novire',
        value: 'novire'
      },
      ];
    this.getShippers();
    this.getZones(this.countryCode);
    this.getMaterials();
    this.getVehicleTypes();
    this.carrierId = this.event.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getShippers();
        this.getZones( this.countryCode);
        this.getMaterials();
        this.getVehicleTypes();
      }
    );
    this.vehicle_pattern = environment.vehicle_pattern;
    // this.vehicleTypes = this.parentData;
  }
  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.allVehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  addSpotVehicle() {
    console.log(this.dedicated_to);
    if (!this.validate(this.spotDriverData)) {
      return;
    }
    this.spotVehicleData.vehicle_type = this.vehicleType1.id;
    console.log(this.dedicated_to);
    this.spotVehicleData.dedicated_to = this.dedicated_to;
    this.selectedMaterial = [];
    this.selectedMaterial = this.material;
    const payload: any = {
      vehicle_type: this.vehicle,
      vehicle_no: this.spotVehicleData.vehicle_no,
      carrier_type: this.carrier_type,
      mobile: this.spotDriverData.mobile,
      name: this.spotDriverData.name,
      // dedicated_to: this.shipper,
      //  dedicated_to: this.dedicatedId,
      // registered_for: this.registeredForId,
      //selectedCarrier: this.carrier,
      // selectedCarrier: this.carriredId,
      capacity: this.capacityData.capacity.toString(),
      preferred_zone: this.preferred.zone,
      preferred_location: this.preferred.location,
     // material: this.selectedMaterial,
     materials: this.materialList,
    };
    if (this.driverImage) payload.driver_image = this.driverImage;
    if (this.spotVehicleData.driver_licence_no)
      payload.driver_licence_no = this.spotVehicleData.driver_licence_no;
    // if (this.spotVehicleData.rc_book_number) payload.rc_book_number = this.spotVehicleData.rc_book_number;
    if (this.capacityData.capacity)
      payload.capacity = this.capacityData.capacity.toString();
    if (this.spotVehicleData.driver_licence_expiry_date)
      payload.driver_licence_expiry_date =
        this.spotVehicleData.driver_licence_expiry_date;
    if (this.spotVehicleData.driver_licence_no)
      payload.driver_licence_no = this.spotVehicleData.driver_licence_no;
    if (this.capacityData.capacity)
      payload.capacity = this.capacityData.capacity.toString();
    if (this.capacityData.rc_Laden_weight)
      payload.rc_laden = this.capacityData.rc_Laden_weight;
    if (this.capacityData.vehicle_qty)
      payload.vehicle_weight = this.capacityData.vehicle_qty;
    if (this.spotVehicleData.driver_licence_expiry_date)
      payload.driver_licence_expiry_date =
        this.spotVehicleData.driver_licence_expiry_date;
    if (this.customer_name) payload.customer_name = this.customer_name;
    // if (this.comments) payload.comments = this.comments;
    if (this.spotVehicleData.dedicated_to){
      payload.dedicated_to = this.spotVehicleData.dedicated_to;
    }


    if (this.engine_number) payload.engine_number = this.engine_number;
    if (this.chassis_number) payload.chassis_number = this.chassis_number;
    if (this.insurance) payload.insurance = this.insurance;
    if (this.selectedGPSProvider) payload.gps_provider = this.selectedGPSProvider;
    this.showLoader = true;
    this.http.post('v1/partial_attached_driver/add', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar('Success', '');
          this.showLoader = false;
          // this.clearData();
          this.router.navigateByUrl('partialRegistrationDashboard');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  selectGPSProvider(provider) {
    this.selectedGPSProvider = provider;
  }
  applyFilter(value) {
    let data = this.capacityData;
    this.capacityData.capacity =
      this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight;
  }

  clearData() {
    this.vehicle_number = '';
    this.spotDriverData.name = '';
    this.spotDriverData.mobile = '';
    this.spotVehicleData.vehicle_no = '';
    this.spotVehicleData.driver_licence_no = '';
    this.carrier_type = '';
    this.capacityData.vehicle_qty = 0;
    this.capacityData.rc_Laden_weight = 0;
    this.capacityData.capacity = 0;
    this.preferred.location = '';
    this.vehicle = '';
    this.expiryDate = '';
    this.carrier = '';
    this.shipper = '';
    this.preferred.location = '';
    this.preferred.zone = '';
    this.carriredId = '';
    this.dedicatedId = '';
    this.registeredForId = '';
    this.customer_name = '';
    this.chassis_number = '';
    this.engine_number = '';
    this.insurance.no = '';
    this.insurance.expiry = '';
    this.materialList =[{name:'',load:0}];
    this.selectedGPSProvider= ''
  }


  getZones(country) {
    const payload = {
      country,
    };
    this.http.get('v1/partial_attached_driver/stateDetails', payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data) {
            this.states = data.data;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getDedicatedShippers() {
    this.showLoader = true;
    this.http.get('dedicatedShippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.dedicatedShippersArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.dedicatedShippersArr.push(temp);
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getShippers() {
    this.showLoader = true;
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.shippersArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.shippersArr.push(temp);
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getMaterials() {
    this.showLoader = true;
    this.http.get('v1/constants/materials').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.materialsArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.materialsArr.push(temp);
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getCarrierPrefs() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.vehicle_types.length) {
            this.vehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }


  searchVehicleDetails() {
    const payload = {
      vehicle_no: this.vehicle_number,
    };

    this.http.post('partial_attached_driver/getDetails', payload).subscribe(
      (data: any) => {
        this.clearData();
        
        if (data.data.data) {
          let result = data.data.data;
           
            this.vehicle_number = result.vehicle_no;
            this.spotDriverData.name = result.name;
            this.spotDriverData.mobile = result.mobile;
            this.spotVehicleData.vehicle_no = result.vehicle_no;
            this.spotVehicleData.comments = result.comments;
            this.spotVehicleData.driver_licence_no = result.licence.no;
            if (result.driver_image) this.driverImage = result.driver_image.name;
            this.carrier_type = result.carrier_type;
            this.capacityData.vehicle_qty = result.vehicle_weight;
            this.capacityData.rc_Laden_weight = result.rc_laden;
            this.capacityData.capacity = result.capacity  ;
            this.selectedGPSProvider = result.gps ? result.gps.provider : '';
            this.vehicle = result.vehicle_type._id;
            this.expiryDate = result.licence.expiry_date;
            this.carrier = result.carrier_unit ? result.carrier_unit.name : '';
            this.carriredId = result.carrier_unit ? result.carrier_unit._id : '';
            this.carrier = (result.carrier && result.carrier.name) ? result.carrier.name : '';
            this.dedicatedId = result.dedicated_to;
            this.registeredForId = result.registered_for;
            this.chassis_number = result.chassis_number;
            this.insurance.no = result.insurance.no;
            this.insurance.expiry = result.insurance.expiry;
            this.engine_number = result.engine_number;
            this.preferred.location = result.preferred_location;
            this.preferred.zone = result.preferred_zone;
            this.vehicleType1.name = result.vehicle_type.name;
            this.customer_name = result.customer_name
            // this.materialList = result.materials.name;
            if (this.dedicatedShippersArr.length > 0) {
              let dedicated = this.dedicatedShippersArr.filter(x => x._id == result.dedicated_to);
              this.dedicatedShipper = dedicated ? dedicated[0].name : '';
            }
            if (this.shippersArr.length > 0) {
              let dedicated = this.shippersArr.filter(x => x._id == result.registered_for);
              this.registeredShipper = dedicated ? dedicated[0].name : '';
            }

          
            
        
          console.log('this->', this.carriredId);
        } else {
          this.snackbar.openSnackBar('No Data Found', '', 'err');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  selectCarrierList(value) {
    this.carrier = value.parent_name;
    this.carriredId = value._id;
  }
  // selectdedicated(value) {
  //   this.enbleMaterial = false;
  //   this.dedicatedShipper = value.name;
  //   this.dedicatedId = value._id;
  //   this.getMaterials();
  // }
  // selectShipper(value) {
  //   this.shipper = value.name;
  //   this.registeredForId = value._id;
  // }
  setExpiryDate(date, change = '', type) {
    if (!change) {
      const temp: any = this.timeService.IsoToUTC(date);
      if (type == 'licence_expiry') {
        this.spotVehicleData.driver_licence_expiry_date = temp.ts;
      } else {
        this.insurance.expiry = temp.ts;
      }
    } else {

      if (type == 'licence_expiry') {
        this.spotVehicleData.driver_licence_expiry_date = this.timeService.toUTCEpoch(date);
      } else {
        this.insurance.expiry = this.timeService.toUTCEpoch(date);
      }

    }
  }

  seInvExpiryDate(date, change = '') {
    if (!change) {
      const temp: any = this.timeService.IsoToUTC(date);
      this.spotVehicleData.driver_licence_expiry_date = temp.ts;
    } else {
      this.spotVehicleData.driver_licence_expiry_date =
        this.timeService.toUTCEpoch(date);
    }
  }

  validate(spotDriverData) {
    if (
      !this.valid.isEmpty(this.spotDriverData.name) &&
      !this.valid.isEmpty(this.spotDriverData.mobile)
    ) {
      if (!this.valid.isMobile(this.spotDriverData.mobile)) {
        this.snackbar.openSnackBar(
          this.translate.instant('Enter a valid mobile'),
          '',
          'err'
        );
        return false;
      }
     let names= this.materialList.filter(x=>x.name=='');

     if (names.length>0) {
      this.snackbar.openSnackBar(
        this.translate.instant('Enter a valid materials details'),
        '',
        'err'
      );
       return false;
     }

    } else {
      this.snackbar.openSnackBar(
        this.translate.instant('Please enter all required details'),
        '',
        'err'
      );
      return false;
    }
    return true;
  }


  // populate assets when provider is selected



  //----------------------

  selectVehicleType(event) {
    if (!event.checked) {
      this.vehicleType1.id = this.selectedVehicleType.id;
      this.vehicleType1.name = this.selectedVehicleType.name;
    } else {
      this.vehicleType1.id = '';
      this.vehicleType1.name = '';
    }
  }
  selectedVehicle(data) {
    this.vehicle_number = data.vehicle;
    this.spotDriverData.name = data.driverName;
    this.spotDriverData.mobile = data.driverMobile;
    this.spotVehicleData.vehicle_no = data.vehicle;

    this.spotVehicleData.driver_licence_no = data.licence.no;
    this.carrier_type = data.carrier_type;
    this.capacityData.vehicle_qty = 0;
    this.capacityData.rc_Laden_weight = 0;
    this.capacityData.capacity = data.capacity;
    this.preferred.location = '';
    this.vehicle = data.vehicle_type._id;
    this.expiryDate = data.licence.expiry_date;
    this.carrier = data.carrier_unit._id;
    this.shipper = data.dedicated_to;
    this.preferred.location = data.preferred_location;
    this.preferred.zone = data.preferred_zone;
  }
  selectCarrier(element) {
    this.selectedUnit = element;
  }
  selectVehicle(vehicle) {
    this.vehicleType1.id = vehicle._id;
    this.vehicleType1.name = vehicle.name;
  }
  selectMaterial(mat, event,i) {
    if(event.isUserInput) {
      this.enbleMaterial = false;
      let names= this.materialList.filter(x=>x.name==event.source.value);

      if (names.length>0 && this.materialList[i].name!=event.source.value) {
        this.snackbar.openSnackBar(this.translate.instant('Material already selected. Please choose different material'), '', 'err' );
       event.source.deselect();
      
      }
    }
  }
  selectShipper(ship, event) {
    if (event.source._selected && this.registeredForId.indexOf(ship._id) == -1) {
      this.registeredForId.push(ship._id);
    } else if (this.registeredForId.indexOf(ship._id) != -1) {
      this.registeredForId.splice(this.registeredForId.indexOf(ship._id), 1);
    }
  }

  addMaterial(){
    if(this.materialList.length < this.materialsArr.length)
    this.materialList.push({name:'',load:0});
  }

  removeMaterial(i){
    this.materialList.splice(i,1);
  }
  validateVehicleNo(selectedVehicleNo) {
    if (
      environment.country == 'IN' &&
      !this.valid.isVehicle(selectedVehicleNo)
    ) {
      this.snackbar.openSnackBar(
        this.translate.instant('Enter valid vehicle number'),
        '',
        'err'
      );
      return false;
    } else if (
      (environment.country == 'SA' || environment.country == 'BR') &&
      !this.valid.isKsaVehicle(selectedVehicleNo)
    ) {
      this.snackbar.openSnackBar(
        this.translate.instant('Enter valid vehicle number'),
        '',
        'err'
      );
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
